import { Box, Stack, Typography, styled } from '@lingoda/ui';
import type { ReactElement } from 'react';

interface TimeSlotProps {
    slug: string;
    title: string;
    description: string;
    icon?: ReactElement;
    selected?: boolean;
    onClick: (slug: string) => void;
}

export const TimeSlot = ({
    slug,
    title,
    description,
    icon,
    selected = false,
    onClick,
}: TimeSlotProps) => {
    const onClickHandler = () => onClick(slug);

    return (
        <StyledTimeSlotContainer selected={selected} onClick={onClickHandler}>
            <Typography variant="h3">{title}</Typography>
            {icon && <IconWrapper>{icon}</IconWrapper>}
            <Typography variant="body1" htmlColor="text.secondary">
                {description}
            </Typography>
        </StyledTimeSlotContainer>
    );
};

const StyledTimeSlotContainer = styled(Stack, {
    shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected: boolean }>(({ theme, selected }) => ({
    width: 160,
    height: 144,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.shape.borderRadiusSmall,
    backgroundColor: theme.colors.background.default,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none',
    ...(selected && {
        boxShadow: `0 0 0 4px ${theme.colors.background['accent-bold']}`,
        borderColor: theme.colors.border['accent-bold'],
        backgroundColor: theme.colors.background['accent-subtle'],
    }),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    cursor: 'pointer',
    [theme.breakpoints.up('sm')]: {
        width: 185,
        height: 162,
    },
}));

const IconWrapper = styled(Box)({
    width: '72px',
    display: 'flex',
    justifyContent: 'center',
    flex: 'none',
});
